import React from "react";
import { AppRoute } from "./app.route";
import { DateTimeProvider } from "@shared/utility/date-time-service/date-time.context";
import { QueryClient, QueryClientProvider } from "react-query";
import { NotificationProvider } from "@shared/ui/notification/notification.context";
import { appConfig } from "./app.config";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DateTimeProvider
        dateFormat={appConfig.dateFormat}
        dateTimeFormat={appConfig.dateTimeFormat}
      >
        <NotificationProvider>
          <AppRoute />
        </NotificationProvider>
      </DateTimeProvider>
    </QueryClientProvider>
  );
}

export default App;
